import { render } from "./DoctorPage.vue?vue&type=template&id=5b55ee60&scoped=true&ts=true"
import script from "./DoctorPage.vue?vue&type=script&lang=ts"
export * from "./DoctorPage.vue?vue&type=script&lang=ts"

import "./DoctorPage.vue?vue&type=style&index=0&id=5b55ee60&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b55ee60"]])

export default __exports__